export type OfferSelection = 1 | 2 | 3 | 4;

export type Offer = {
  selection: OfferSelection;
  label: string;
  quantity: number;
  total: number;
  compareAt?: number;
  perVial: number;
  note: string;
  ribbon?: string;
};

export const AMINO_OFFERS: Record<1 | 2 | 3, Offer> = {
  1: {
    selection: 1,
    label: '1 vial',
    quantity: 1,
    total: 129,
    perVial: 129,
    note: '+ shipping and handling'
  },
  2: {
    selection: 2,
    label: '2 vials',
    quantity: 2,
    total: 229,
    compareAt: 258,
    perVial: 114.5,
    note: 'Shipping waived where route is approved',
    ribbon: 'Most popular'
  },
  3: {
    selection: 3,
    label: '3 vials',
    quantity: 3,
    total: 297,
    compareAt: 387,
    perVial: 99,
    note: 'Shipping waived - lowest per-vial price',
    ribbon: 'Best value'
  }
};

export const BULK_OFFER = {
  selection: 4 as const,
  label: 'Lab allocation',
  min: 4,
  max: 12,
  perVial: 99,
  note: '4-12 vials - shipping waived'
};

export function money(value: number) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: value % 1 === 0 ? 0 : 2
  }).format(value);
}

export function getOfferSummary(selection: OfferSelection, bulkQty: number) {
  if (selection === 4) {
    const quantity = bulkQty;
    const total = BULK_OFFER.perVial * quantity;
    const compareAt = 129 * quantity;

    return {
      selection,
      label: BULK_OFFER.label,
      quantity,
      total,
      compareAt,
      perVial: BULK_OFFER.perVial,
      note: BULK_OFFER.note,
      savings: compareAt - total
    };
  }

  const offer = AMINO_OFFERS[selection];

  return {
    ...offer,
    savings: offer.compareAt ? offer.compareAt - offer.total : 0
  };
}
